
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Card, CardContent } from '@/components/ui/card';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <div className="container mx-auto px-4 py-12 max-w-3xl flex-grow">
        <h1 className="text-3xl font-bold mb-8 text-center">Contact Us</h1>
        
        <Card className="mb-8">
          <CardContent className="pt-6">
            <p className="mb-6">
              Have questions about our services or need help with your account? Feel free to reach out to us directly via phone or email.
            </p>
            
            <div className="space-y-8">
              <div>
                <h2 className="text-xl font-semibold mb-4">Company Information</h2>
                <p className="font-medium">Legal Entity Name:</p>
                <p className="mb-2">NXT BIZNESS SOLUTIONS</p>
                
                <p className="font-medium mt-4">Registered Address:</p>
                <p className="mb-2">402, 6-3-542/1, Golden Green Apartments,</p>
                <p className="mb-2">Panjagutta, Hyderabad, Telangana,</p>
                <p className="mb-2">India, PIN: 500082</p>
                
                <p className="font-medium mt-4">Operational Address:</p>
                <p className="mb-2">402, 6-3-542/1, Golden Green Apartments,</p>
                <p className="mb-2">Panjagutta, Hyderabad, Telangana,</p>
                <p className="mb-2">India, PIN: 500082</p>
              </div>
              
              <div>
                <h2 className="text-xl font-semibold mb-4">Contact Details</h2>
                <p className="mb-2">Telephone: <a href="tel:+919885390929" className="text-primary hover:underline">+91 9885390929</a></p>
                <p className="mb-2">Email: <a href="mailto:svsashank@gmail.com" className="text-primary hover:underline">svsashank@gmail.com</a></p>
              </div>
              
              <div>
                <h2 className="text-xl font-semibold mb-2">Get in Touch</h2>
                <p className="mb-2">
                  Our support team is available Monday to Friday, 9:00 AM to 6:00 PM IST.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      
      <Footer />
    </div>
  );
};

export default ContactPage;
